export default "__VITE_ASSET__BP_GGCQH__"